import { createAction } from 'redux-actions';

import { isMocked } from './authentication';
import { metaCreator, payloadCreator } from './creator';
import { getDropboxData } from './dropbox';
import { getFhirData, supportedTypes as fhirTypes } from './fhir';
import { getFitData } from './google';
import { getNightscoutData, supportedTypes as nightscoutTypes } from './nightscout';
import { getOuraData, supportedTypes as ouraTypes } from './oura';
import { getOmakantaData, supportedTypes as omakantaTypes } from './omakanta';
import { getWellmoData, supportedTypes as wellmoTypes } from './wellmo';

export const updateAllDataAction = createAction('UPDATE_ALL_DATA');

export const clearAllDataAction = createAction('CLEAR_ALL_DATA');

export const loadMockDataAction = createAction('USER_DATA_LOADED', payloadCreator, metaCreator);

export const updateAllData = ({ params, user }) => ((dispatch) => {
  if (!user || !user.services || !user.services.forEach) {
    return Promise.resolve();
  }
  // for testing
  if (isMocked(user)) {
    return Promise.resolve({});
  }
  const services = user.services.reduce((o, s) => {
    if (s.name || (s.status && s.status === 'ok')) {
      o[s.name || s.service] = true;
    }
    return o;
  }, {});

  const promises = [];
  if (services.dropbox) {
    promises.push(dispatch(getDropboxData({ params })));
  }
  if (services.fhir) {
    fhirTypes.forEach((type) => {
      promises.push(dispatch(getFhirData({ type, params })));
    });
  }
  if (services.google) {
    promises.push(dispatch(getFitData({ params })));
  }
  if (services.nightscout) {
    nightscoutTypes.forEach((type) => {
      promises.push(dispatch(getNightscoutData({ type, params })));
    });
  }
  if (services.omakanta) {
    // Execute sequentially. The token may have been expired, better to refresh it only once.
    const omakantaPromise = omakantaTypes.reduce(
      (p, type) => p.then(() => dispatch(getOmakantaData({ type, params }))),
      Promise.resolve(),
    );
    promises.push(omakantaPromise);
  }
  if (services.oura) {
    // Execute sequentially. The token may have been expired, better to refresh it only once.
    const ouraPromise = ouraTypes.reduce(
      (p, type) => p.then(() => dispatch(getOuraData({ type, params }))),
      Promise.resolve(),
    );
    promises.push(ouraPromise);
  }
  if (services.wellmo) {
    // Execute sequentially. The token may have been expired, better to refresh it only once.
    const wellmoPromise = wellmoTypes.reduce(
      (p, type) => p.then(() => dispatch(getWellmoData({ type, params }))),
      Promise.resolve(),
    );
    promises.push(wellmoPromise);
  }
  return Promise.all(promises);
});

export const clearAllData = () => dispatch => dispatch(clearAllDataAction());

export default updateAllData;
